export default {
  Examination: {
    // lhlong
    ListTitle: 'Danh sách bài kiểm tra',
    SearchPlaceholder: 'Tìm kiếm',
    DoExamination: 'Làm bài',
    Processing: 'Đang diễn ra',
    NotOpen: 'Chưa diễn ra',
    Class: 'Lớp {ClassName}',
    Subject: 'Môn',
    StartTime: 'Thời gian mở đề',
    State: 'Trạng thái',
    ExaminationTitle: 'Tên bài kiểm tra',
    QtyQuestion: 'Số câu hỏi',
    Time: 'Thời gian làm bài',
    NeedReplay: 'Cần xem lại',
    NotDone: 'Chưa làm',
    Done: 'Đã làm',
    Sentence: '{QuestionNo} câu',
    Minute: 'phút',
    CheckExamAgain: 'Soát bài',
    TitleQuestion: 'Câu {Count}',
    Edit: 'Sửa',
    SaveDraft: 'Lưu nháp',
    AnswerSort: '<div class="answer-content font-bold">{0}</div><div class="ml-2">{1}</div>',
    SuccessfulSubmit: 'Nộp bài thành công!',
    WaitForMark: 'Chờ giáo viên chấm điểm và nhận xét nhé!',
    TeacherComment: 'Nhận xét của giáo viên',
    Wrong: 'Làm sai',
    AverageSpeed: 'Tốc độ làm bài trung bình',
    AvgSpeedUnit: 'giây/câu',
    ActualTime: 'Thời gian làm bài thực tế',
    Accuracy: 'Độ chính xác',
    ReviewExam: 'Xem chi tiết bài làm',
    BackToList: 'Quay lại danh sách bài kiểm tra',
    ExaminationReview: 'Chi tiết bài làm',
    NoticeFiveMinutesLeft: 'Đề kiểm tra <b>{title}</b> sẽ tự động đóng trong 5 phút nữa',
    Submit: 'Nộp bài',
    SelectQuestion: 'Chọn đáp án đúng',
    FillQuestion: 'Điền từ',
    YesornoQuestion: 'Đúng sai',
    EssayQuestion: 'Tự luận',
    PlaceholderInputTag: 'Nhập đáp án',
    EssayAnswerTitle: 'Bài làm',
    TeacherPoint: 'Ghi điểm',
    EmptyExamList: 'Chưa có bài kiểm tra',
    NotFountExam: 'Không tìm thấy bài kiểm tra',
    MaxPoint: '{MaxPoint} điểm',
    ExamSubmitted: 'Đã nộp bài',
    WaitingRoom: 'Phòng chờ',
    GoToWaitingRoom: 'Vào phòng chờ',
    InWaitingRoom: 'Trong phòng chờ ({ReadyQty})',
    NotReady: 'Chưa tham gia ({NotReadyQty})',
    RemainingTimeToOpen: 'Thời gian đến giờ mở đề',
    Hour: 'Giờ',
    MinuteUpperFirstCase: 'Phút',
    Second: 'Giây',
    TimeToDoExam: 'Đã đến giờ làm bài!',
    TimeDoExamNotify: 'Giáo viên sẽ mở đề trong ít phút',
    ResetMessage: 'Nhấn nút <b>Nạp lại</b> nếu </br>không vào làm bài được',
    WrongExamMessage: 'Vui lòng liên hệ với giáo viên để lấy đường dẫn phòng chờ của lớp',

    // pqhieu
    SuccessSubmit: 'Nộp bài thành công!',
    SuccessComplete: 'Hoàn thành bài tập!',
    AnwserExam: 'Nhấn "Tiếp tục" để xem kết quả bài làm',
    OtherExam: 'Nhấn "Tiếp tục" để làm bài tập khác',
    TimeNotiFy: 'Kết quả sẽ được nhận vào ',
    TimeExam: '{timeDeadline} - {dateDeadline}.',

    // TTLONG
    AnwserResultExam: 'Nhấn "Xem kết quả" để xem kết quả bài làm',
    School: 'Toàn trường',
    Grade: 'Khối',
    Student: 'Học sinh tham gia',
    StudentNumber: '{numberStudent} học sinh',

    // PBAC
    DoByList: 'Làm dạng danh sách',
    DoBySingle: 'Làm dạng từng câu',
    NextQuestion: 'Câu tiếp',
    CongratFinnishAll: 'Bạn đã hoàn thành bài kiểm tra',
    CheckAgainBeforeSubmit: 'Kiểm tra lại bài trước khi nộp',
    ExamSortOrder: 'Đề số {sortOrder}'
  }
}
